import {createSelector} from 'reselect';
import {getSettings} from '../selectors';

export default deliveryOptionId => createSelector(
  [getSettings],
  settings => !!(settings.hide_delivery_estimate_by_id
    && settings.hide_delivery_estimate_by_id.includes(deliveryOptionId)),
);
